import { Menu } from "@mui/material";
import ListItemButton from "@mui/material/ListItemButton";
import { styled } from "@mui/material/styles";

export const NavigationMenuStyled = styled(Menu)(({ theme }) => ({
  "& .MuiPaper-root": {
    width: "240px",
    overflow: "visible",
    filter: "drop-shadow(0px 0px 24px rgba(0,0,0,0.04))",
    mt: theme.spacing(1),
  },

  "& .MuiList-root": {
    padding: "16px",
  },
}));

export const NavigationMenuItemStyled = styled(ListItemButton)(({ theme }) => ({
  "& .MuiButton-startIcon > *:nth-of-type(1)": {
    fontSize: "1.5rem", // or any value
  },
  "color": theme.palette.text.primary,
  "borderRadius": "36px",
  "padding": "0px 16px",
  "marginRight": "8px",
  "textTransform": "none",
  "fontWeight": theme.typography.fontWeightMedium,
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
  "&.Mui-selected": {
    "color": theme.palette.primary.main,
    "border": `1px solid ${theme.palette.primary.main}`,
    "backgroundColor": "transparent",
    "& .MuiListItemIcon-root": {
      color: theme.palette.primary.main,
    },
  },
  "& .MuiListItemIcon-root": {
    minWidth: "auto",
  },
}));
